import SubHeader from "../components/SubHeader";
import "antd/dist/antd.css";
//RUN: new header component 16/04/2021
import HeaderComponent from "../components/HeaderComponent";
import LoginScreen from "./LoginScreen";
import { Redirect } from "react-router";
import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import React, { useState, useEffect } from "react";
import { Drawer, Card, Table, Spin, PageHeader, Radio, Tabs, Button, Select, DatePicker, Space, Input, Skeleton, Form } from 'antd';
import { SaveOutlined, PlusOutlined, DeleteTwoTone } from '@ant-design/icons';
import * as _ from "lodash"; //
import moment from "moment";
import Dialog from '../shared/dialog';
const titleTH = 'บันทึกข้อมูลประวัติการฉีดวัคซีน และ ประวัติการตรวจเชื้อ Covid-19';
const titleEN = 'Covid-19 vaccine and detection history'
const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';
const weekFormat = 'MM/DD';
const monthFormat = 'YYYY/MM';
const newDate = Date.now();
const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
const CovidInfoAdd = () => {
  const [values, setValues] = useState({
    CoDetailID: 0,
    Emp_id: localStorage.getItem('EmpId'),
    VacState: 0,
    ReasonUnVac: null,
    RemarkUnvac: null,
    DetectHistory: 0,
  });
  const {
    VacState,
    ReasonUnVac,
    DetectHistory,
    CoDetailID,
    RemarkUnvac
  } = values;
  const [vac, setVac] = useState([]);
  const [VachistoryInfo, setVacHistory] = useState([]);
  const [CovidDetectHistory, setCovidDetectHistory] = useState([]);
  const {
    Dose,
    OtherVaccine
  } = VachistoryInfo;
  const dialog = new Dialog();
  const init = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/getCovidHistory", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    }).then((Response) => Response.json())
      .then((result) => {
        console.log('ccdcdcdcdcd', result)
        console.log('ccdcdcdcdcd', result[0].covidHistory)
        // result[0].covidHistory.map((data, index) => {
        //   data['ObjectState'] = 0
        // })
        // result[0].covidDetectHistory.map((data, index) => {
        //   data['ObjectState'] = 0
        // })

        setVac(
          result[0].vaccinetypes
        )
        // setValues(
        //   result[0].CovidDetails[0]
        // )
        // setVacHistory(
        //   result[0].covidHistory
        // )
        // setCovidDetectHistory(
        //   result[0].covidDetectHistory
        // )

      });
  };

  const changeLang = (lang) => {
    console.log('sssssss')
  }
  const clickSubmit = (event) => {
    console.log(' clickSubmitevent', event)
    var temp = VachistoryInfo.filter(e => {
      return e.ObjectState !== -1
    })
    var tempCovidHis = CovidDetectHistory.filter(e => {
      return e.ObjectState !== -1
    })

    var vacOther = VachistoryInfo.filter(e => {
      return e.VacID == 7 && (e.OtherVaccine == ''
        || e.OtherVaccine == null
        || e.OtherVaccine == undefined
      )
    })
    console.log('temp', temp)
    if (vacOther.length == 0) {
      if ((VacState == 0 && temp.length > 0)
        || (VacState == 1 && ReasonUnVac !== null)
        // || (VacState == 1 && ReasonUnVac !== null)
      ) {
        if (DetectHistory == 0) {
          fetch(process.env.REACT_APP_API_URL + "/api/saveCovidHistory", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },

            body: JSON.stringify({
              empid: localStorage.getItem("EmpId"),
              VachistoryInfo: temp,
              CovidDetectHistory: tempCovidHis,
              CovidDetails: values
            }),
          }).then((Response) => Response.json())
            .then((result) => {
              if (result.status == "404") {
                if (localStorage.getItem('Language') == 'TH') {
                  dialog.WarningDialog(
                    'บันทึกไม่สำเร็จ')
                } else {
                  dialog.WarningDialog(
                    'Unable to Save')
                }
              } else {
                if (localStorage.getItem('Language') == 'TH') {
                  dialog.SuccessDialog('บันทึกสำเร็จ', '/vaccine-info')

                } else {
                  dialog.SuccessDialog('Save Successful', '/vaccine-info')
                }

                localStorage.removeItem("covidInfoStatus");
                localStorage.setItem("covidInfoStatus", "1");
              }
            })

        } else if (DetectHistory == 1) {
          fetch(process.env.REACT_APP_API_URL + "/api/saveCovidHistory", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },

            body: JSON.stringify({
              empid: localStorage.getItem("EmpId"),
              VachistoryInfo: temp,
              CovidDetectHistory: tempCovidHis,
              CovidDetails: values
            }),
          }).then((Response) => Response.json())
            .then((result) => {
              if (result.status == "404") {
                if (localStorage.getItem('Language') == 'TH') {
                  dialog.WarningDialog(
                    'บันทึกไม่สำเร็จ')
                } else {
                  dialog.WarningDialog(
                    'Unable to Save')
                }

              } else {
                if (localStorage.getItem('Language') == 'TH') {
                  dialog.SuccessDialog('บันทึกสำเร็จ', '/vaccine-info')

                } else {
                  dialog.SuccessDialog('Save Successful', '/vaccine-info')
                }
                localStorage.removeItem("covidInfoStatus");
                localStorage.setItem("covidInfoStatus", "1");
              }
            })

        } else {
          if (localStorage.getItem('Language') == 'TH') {
            dialog.WarningDialog(
              'บันทึกไม่สำเร็จ')
          } else {
            dialog.WarningDialog(
              'Unable to Save')
          }
        }

      } else {
        if (localStorage.getItem('Language') == 'TH') {
          dialog.WarningDialog(
            'บันทึกไม่สำเร็จ กรุณาเพิ่มข้อมูลการฉีดวัคซีนในตารางด้านล่าง')
        } else {
          dialog.WarningDialog(
            'Unable to Save. Please fill out your vaccine information')
        }

      }
    } else {
      if (localStorage.getItem('Language') == 'TH') {
        dialog.WarningDialog(
          'บันทึกไม่สำเร็จ กรุณากรอกชนิดวัคซีน')
      } else {
        dialog.WarningDialog(
          'Unable to Save. Please fill out vaccine name.')
      }

    }
  }
  const handleChange = (name) => (event) => {
    const value = event.target.value;
    setValues({ ...values, [name]: value });
  };

  const handleChangeVacHistory = (name, indexData, data, dose) => async (event) => {
    var value
    var VacID
    var VacNameEN
    var nullvalue = null
    if (name == 'VacNameTH' || name == 'VacDate') {
      if (name == 'VacNameTH') {
        data.map((vtypes, index) => {
          if (vtypes.VacNameTH == event) {
            VacID = vtypes.VacID
            VacNameEN = vtypes.VacNameEN
            value = event
          }
        })
      } else {
        if (event == null) {
          value = null
        } else {
          value = moment(event).format('YYYY/MM/DD')
        }
      }

    } else {
      value = event.target.value;
    }
    // console.log('typeof VachistoryInfo', typeof VachistoryInfo)
    console.log('value', value)

    await setVacHistory(prevstate =>
      [
        ...prevstate.map((data, index) => {
          if (index == indexData) {
            if (name == 'VacNameTH') {
              data[name] = value
              data['VacID'] = VacID
              data['VacNameEN'] = VacNameEN
            } else {
              data[name] = value
            }
        
          } else if (name == 'VacDate') {
            console.log('ddddddd', dose)
            if (event !== null) {
              if (dose < data['Dose']) {
                if (value > moment(data['VacDate']).format('YYYY/MM/DD')) {
                  console.log('inside value parse')
                  data['VacDate'] = null
              
                }
              }
            }
          }



          return data
        })
      ]

    )

  };
  const handleChangeDetectHistory = (name, indexData, data) => (event) => {
    var value
    // const { name, value } = event.target;
    if (name == 'DetectDate' || name == 'CuredDate') {
      if (event !== null) {
        value = moment(event).format('YYYY/MM/DD')
      } else {
        value = null
      }
    } else {
      value = event
    }
    // console.log('typeof VachistoryInfo', typeof VachistoryInfo)
    console.log('value', value)

    setCovidDetectHistory(prevstate =>
      [
        ...prevstate.map((data, index) => {
          if (index == indexData) {
            data[name] = value
            if (name == 'DetectDate' && value !== null) {
              console.log('inssss', value)
              console.log('inssss data curedData', moment(data['CuredDate']).format('YYYY/MM/DD'))
              if (value > moment(data['CuredDate']).format('YYYY/MM/DD')) {
                console.log('inside value parse')
                data['CuredDate'] = null
              }
            }
            if (data['ObjectState'] !== 1) {
              data['ObjectState'] = 2
            }
          }
          return data
        })
      ]
    )
    // setCovidDetectHistory(prevstate =>
    //   [
    //     ...prevstate.map((data, index) => {
    //       if (index == indexData) {
    //         data[name] = value
    //         if (data['ObjectState'] !== 1) {
    //           data['ObjectState'] = 2
    //         }
    //       }
    //       return data
    //     })
    //   ]
    // )

  };


  function callback(key) {
    console.log(key);
  }
  const clickDeleteDetectHistory = (indexData) => async (event) => {
    console.log('in click delete now index of :', indexData)
    await setCovidDetectHistory(prevstate =>
      [
        ...prevstate.map((data, index) => {
          if (index == indexData) {
            data['ObjectState'] = -1
          }
          return data
        })
      ]
    )
    RefreshDetectCount(CovidDetectHistory);

  }

  const disabledDateDose = (currentdetectdate, dose, indexData) => (event) => {
    let temp = VachistoryInfo.filter(e => {
      return e.Dose == (dose - 1)
    })
    if (dose > 1) {
      return event && event < moment(temp[0].VacDate, "YYYY-MM-DD");
    }
  }

  const disabledDate = (currentdetectdate) => (event) => {
    return event && event < moment(currentdetectdate, "YYYY-MM-DD");
  }
  const clickDeleteVaccineHistory = (indexData, dataDose) => async (event) => {
    console.log('in click delete now index of :', indexData)
    var counter = 0
    var count = 0
    await setVacHistory((prevstate) =>
      [
        ...prevstate.map((data, index) => {
          console.log('index', index)
          console.log('indexData', indexData)
          if (index == indexData) {
            data['ObjectState'] = -1
          }
          return data
        })
      ]
    )
    console.log('ssssssssssssssss', VachistoryInfo)
    RefreshDoses(VachistoryInfo)

  }
  const columnsTH = [
    {
      title: '',
      dataIndex: 'Action',
      width: '0.1%',
      className: 'HeadVac columnvac vactd'
    },
    {
      title: 'เข็มที่',
      dataIndex: 'Dose',
      width: '0.001%',
      className: 'HeadVac columnvac vactd'
    },
    {
      title: 'ชื่อวัคซีน',
      dataIndex: 'VacNameTH',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'วันที่ได้รับวัคซีน',
      dataIndex: 'VacDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'
    },


  ];

  const columnEN = [
    {
      title: '',
      dataIndex: 'Action',
      width: '0.1%',
      className: 'HeadVac columnvac vactd'
    },
    {
      title: 'Dose',
      dataIndex: 'Dose',
      width: '0.001%',
      className: 'HeadVac columnvac vactd'
    },
    {
      title: 'Name of Vaccine',
      dataIndex: 'VacNameEN',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'Date of Vaccination',
      dataIndex: 'VacDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'
    },

  ];

  const tableDataTH = [];
  {
    console.log('jjjjjjjjjjjjjjj', VachistoryInfo)
    if (VachistoryInfo) {
      VachistoryInfo.map((data, index) => {
        if (data.ObjectState !== -1) {

          tableDataTH.push({
            key: index,
            Action: (
              <Button
                type="error"
                size="large"
                style={{ margin: 15, float: 'right' }}
                onClick={clickDeleteVaccineHistory(index)}
                icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
              >
              </Button>
            ),
            // Dose: index + 1,
            Dose: tableDataTH.length + 1,

            VacNameTH: (
              <div className="select-cell-table">
                <Select
                  placeholder=""
                  bordered
                  value={data.VacNameTH}
                  style={{ width: '20em' }}
                  onChange={handleChangeVacHistory("VacNameTH", index, vac,data.Dose)}
                >
                  {vac.map((vactype) => (
                    <Option value={vactype.VacNameTH}
                    >
                      {vactype.VacNameTH}
                    </Option>
                  ))}
                </Select>
                {data.VacID == 7 ?
                  <div>
                    <div>
                      <label>โปรดระบุชื่อวัคซีน: </label>
                    </div>
                    <Input
                      name='OtherVaccine'
                      value={data.OtherVaccine}
                      type='string'
                      style={{ textAlign: "center", width: '20em' }}
                      onChange={handleChangeVacHistory("OtherVaccine", index, data,data.Dose)}
                    />

                  </div>
                  :
                  null

                }
              </div>
            ),
            // VacDate: moment(data.VacDate).format("DD/MM/YYYY"),
            VacDate: data.VacDate !== null ? (
              <DatePicker value={moment(data.VacDate, dateFormat)}
              format={dateFormat}

                disabledDate={disabledDateDose(data.VacDate, data.Dose, index)}
                onChange={handleChangeVacHistory("VacDate", index, data,data.Dose)}
              />
            ) :
              (
                <DatePicker format={dateFormat}
                  disabledDate={disabledDateDose(data.VacDate, data.Dose, index)}
                  onChange={handleChangeVacHistory("VacDate", index, data,data.Dose)}
                />
              )
          })
        }
      })

    }

  }

  const tableDataEN = [];
  {
    console.log('jjjjjjjjjjjjjjj', VachistoryInfo)
    if (VachistoryInfo) {
      VachistoryInfo.map((data, index) => {
        if (data.ObjectState !== -1) {
          console.log('data', data)
          tableDataEN.push({
            key: index,
            Action: (
              <Button
                type="error"
                size="large"
                style={{ margin: 15, float: 'right' }}
                onClick={clickDeleteVaccineHistory(index)}
                icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
              >
              </Button>
            ),
            // Dose: index,
            Dose: tableDataEN.length + 1,


            // VacNameTH: data.VacNameTH,
            VacNameEN: (
              <div className="select-cell-table">
                <Select
                  placeholder=""
                  bordered
                  value={data.VacNameEN}
                  style={{ width: '20em' }}
                  onChange={handleChangeVacHistory("VacNameEN", index, vac,data.Dose)}
                >
                  {vac.map((vactype) => (
                    <Option value={vactype.VacNameEN}
                    >
                      {vactype.VacNameEN}
                    </Option>
                  ))}
                </Select>
                {data.VacID == 7 ?
                  <div>
                    <div>
                      <label>Please specify vaccine name: </label>
                    </div>
                    <Input
                      name='OtherVaccine'
                      value={data.OtherVaccine}
                      type='string'
                      style={{ textAlign: "center", width: '20em' }}
                      onChange={handleChangeVacHistory("OtherVaccine", index, data,data.Dose)}
                    />

                  </div>
                  :
                  null

                }
              </div>
            ),
            // VacDate: moment(data.VacDate).format("DD/MM/YYYY"),
            VacDate: data.VacDate !== null ? (
              <DatePicker value={moment(data.VacDate, dateFormat)}
                format={dateFormat}
                disabledDate={disabledDateDose(data.VacDate, data.Dose, index)}
                onChange={handleChangeVacHistory("VacDate", index, data,data.Dose)}
              />
            ) :
              (
                <DatePicker format={dateFormat}
                  disabledDate={disabledDateDose(data.VacDate, data.Dose, index)}
                  onChange={handleChangeVacHistory("VacDate", index, data,data.Dose)}
                />
              )
          })
        }
      })

    }

  }

  const columnsCovidDetctHistoryTH = [
    {
      title: '',
      dataIndex: 'Action',
      width: '0.1%',
      className: 'HeadVac columnvac vactd'
    },
    {
      title: 'ครั้งที่',
      dataIndex: 'DetectCount',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'ประเภทการตรวจ',
      dataIndex: 'Type',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'วันที่ตรวจพบเชื้อ',
      dataIndex: 'DetectDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'วันที่รักษาหาย',
      dataIndex: 'CuredDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },

  ];

  const columnsCovidDetctHistoryEN = [
    {
      title: '',
      dataIndex: 'Action',
      width: '0.1%',
      className: 'HeadVac columnvac vactd'
    }
    , {
      title: 'No',
      dataIndex: 'DetectCount',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'Detection Type',
      dataIndex: 'Type',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'Date of detection',
      dataIndex: 'DetectDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },
    {
      title: 'Date of recovery',
      dataIndex: 'CuredDate',
      width: '10%',
      className: 'HeadVac columnvac vactd'

    },

  ];

  const tableDetectHistoryTH = [];
  {
    if (CovidDetectHistory) {
      CovidDetectHistory.map((data, index) => {
        if (data.ObjectState !== -1) {

          tableDetectHistoryTH.push({
            key: index,
            Action: (
              <Button
                type="error"
                size="large"
                style={{ margin: 15, float: 'right' }}
                onClick={clickDeleteDetectHistory(index)}
                icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
              >
              </Button>
            ),
            DetectCount: tableDetectHistoryTH.length + 1,
            // Type: data.Type == 0 ? 'ATK' : 'RT-PCR',
            Type: (
              <div className="select-cell-table">
                <Select
                  placeholder=""
                  bordered
                  value={data.Type}
                  style={{ width: '100%' }}
                  onChange={handleChangeDetectHistory("Type", index, vac)}
                >
                  <Option value={0}> ATK </Option>
                  <Option value={1}> RT-PCR</Option>
                </Select>
              </div>
            ),
            DetectDate: data.DetectDate !== null ?
              (<DatePicker defaultValue={moment(data.DetectDate, dateFormat)}
              format={dateFormat}
                onChange={handleChangeDetectHistory("DetectDate", index, data)}
              />)
              :
              (<DatePicker format={dateFormat}
                onChange={handleChangeDetectHistory("DetectDate", index, data)}
              />)
            ,
            CuredDate: data.CuredDate === null ?
              (
                // <RangePicker />
                <DatePicker format={dateFormat}
                  disabled={data.DetectDate === null ? true : false}
                  disabledDate={disabledDate(data.DetectDate)}
                  onChange={handleChangeDetectHistory("CuredDate", index, data)}
                />
              )
              :
              (<DatePicker value={moment(data.CuredDate, dateFormat)}
              format={dateFormat}
                disabledDate={disabledDate(data.DetectDate)}
                onChange={handleChangeDetectHistory("CuredDate", index, data)}
              />)
            ,

          })
        }
      })
    }

  }


  const tableDetectHistoryEN = [];
  {
    if (CovidDetectHistory) {
      CovidDetectHistory.map((data, index) => {
        if (data.ObjectState !== -1) {
          tableDetectHistoryEN.push({
            key: index,
            Action: (
              <Button
                type="error"
                size="large"
                style={{ margin: 15, float: 'right' }}
                onClick={clickDeleteDetectHistory(index)}
                icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
              >
              </Button>
            ),
            DetectCount: tableDetectHistoryEN.length + 1,
            // Type: data.Type == 0 ? 'ATK' : 'RT-PCR',
            Type: (
              <div className="select-cell-table">
                <Select
                  placeholder=""
                  bordered
                  value={data.Type}
                  style={{ width: '100%' }}
                  onChange={handleChangeDetectHistory("Type", index, vac)}
                >
                  <Option value={0}> ATK </Option>
                  <Option value={1}> RT-PCR</Option>
                </Select>
              </div>
            ),
            DetectDate: data.DetectDate !== null ?
              (<DatePicker defaultValue={moment(data.DetectDate, dateFormat)}
              format={dateFormat}
                onChange={handleChangeDetectHistory("DetectDate", index, data)}
              />)
              :
              (<DatePicker format={dateFormat}
                onChange={handleChangeDetectHistory("DetectDate", index, data)}
              />)
            ,
            CuredDate: data.CuredDate === null ?
              (
                // <RangePicker />
                <DatePicker format={dateFormat}
                  disabled={data.DetectDate === null ? true : false}
                  disabledDate={disabledDate(data.DetectDate)}
                  onChange={handleChangeDetectHistory("CuredDate", index, data)}
                />
              )
              :
              (<DatePicker value={moment(data.CuredDate, dateFormat)}
                disabledDate={disabledDate(data.DetectDate)}
                format={dateFormat}
                onChange={handleChangeDetectHistory("CuredDate", index, data)}
              />),

          })
        }
      })
    }


  }
  const clickAddDetect = (event) => {
    var temp = CovidDetectHistory.filter(e => {
      return e.ObjectState !== -1
    })
    console.log('in click add')
    let newDetectModel = {
      CoHistoryID: null,
      CoDetailID: CoDetailID,
      DetectCount: temp.length + 1,
      Emp_id: localStorage.getItem('EmpId'),
      Type: 0,
      DetectDate: null,
      CuredDate: null,
      ObjectState: 1
    }
    setCovidDetectHistory((prevState) => (
      [...prevState, newDetectModel]
    )
    )
  }
  const clickAdd = (event) => {
    var temp = VachistoryInfo.filter(e => {
      return e.ObjectState !== -1
    })
    console.log('in click add')
    let newModel = {
      CoDetailID: CoDetailID,
      Dose: temp.length + 1,
      Emp_id: localStorage.getItem('EmpId'),
      Status: 0,
      VacDate: null,
      VacHistID: null,
      VacID: 1,
      VacNameEN: "Sinovac",
      VacNameTH: "ซีโนแวค",
      ObjectState: 1
    }
    setVacHistory((prevState) => (
      [...prevState, newModel]
    )
    )
  }

  const RefreshDetectCount = async (das) => {
    let count = 0
    let tempDetectCount = das.filter(e => {
      return e.ObjectState !== null
    })
    tempDetectCount.forEach(async ele => {
      if (ele.ObjectState == -1) {
        //do nothing
      } else {
        if (ele.ObjectState == 0 || ele.ObjectState == 2) {
          count = count + 1
          console.log('in count ', count)
          ele.DetectCount = count
          ele.ObjectState = 2
        } else if (ele.ObjectState == 1) {
          count = count + 1
          ele.DetectCount = count
        }
      }
    })

    setCovidDetectHistory(tempDetectCount
    )


  }
  const RefreshDoses = async (das) => {
    let count = 0
    let tempVac = das.filter(e => {
      return e.ObjectState !== null
    })

    tempVac.sort((one, two) => one.Dose - two.Dose)

    console.log('tempVac sorted', tempVac)
    tempVac.forEach(async ele => {
      if (ele.ObjectState == -1) {
        ele.Dose = ele.Dose * -1
      } else {
        if (ele.ObjectState == 0 || ele.ObjectState == 2) {
          count = count + 1
          console.log('in count ', count)
          ele.Dose = count
          ele.ObjectState = 2
        } else if (ele.ObjectState == 1) {
          count = count + 1
          ele.Dose = count
        }
      }
    })
    console.log('tempVac', tempVac)

    setVacHistory(tempVac
    )


  }
  useEffect(() => {
    init();
  }, []);
  const newPostFormTH = () => (
    <div style={{ marginBlock: 15 }}>
      <Form className="mb-3" style={{ margin: 15 }} onFinish={clickSubmit}>
        <Tabs style={{ marginLeft: 10, overflow: 'auto' }} defaultActiveKey="1" onChange={callback}
          tabBarExtraContent={<Form.Item>
            <Button type="primary"
              size="large"
              style={{ float: 'right' }}
              // onClick={clickSubmit} 
              htmlType="submit"
            >
              บันทึกข้อมูล
            </Button>
          </Form.Item>}
        >
          <TabPane tab="ข้อมูลการฉีดวัคซีน" key="1">

            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '5%' }}>
                <h2>ท่านได้รับวัคซีนโควิด-19 แล้วหรือไม่ </h2> :

                <Radio.Group onChange={handleChange("VacState")} style={{ fontSize: '1em' }} value={VacState}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={0}>ได้รับแล้ว</Radio>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={1}>ยังไม่ได้รับ</Radio>
                </Radio.Group>
              </div>
            </div>
            {VacState == 0 ?
              <div style={{ marginBottom: '5%' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAdd}
                // icon={<PlusOutlined />}
                >
                  เพิ่มข้อมูล
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnsTH}
                    dataSource={tableDataTH}
                    pagination={false}
                  />
                </div>
              </div>
              :
              <div>
                <div style={{ textAlign: 'center' }}>
                  <h2>ท่านยังไม่ได้รับวัคซีนด้วยเหตุผลใด </h2>
                </div>
                <Radio.Group onChange={handleChange("ReasonUnVac")}
                  style={{ fontSize: '1em', marginLeft: '18%' }} value={ReasonUnVac}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={0}>
                    ไม่ประสงค์จะรับวัคซีน
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={1}>
                    จองหรือลงทะเบียนรับวัคซีนแล้ว อยู่ระหว่างรอเข้ารับวัคซีน
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={2}>
                    รอวัคซีนทางเลือก
                  </Radio>
                  <br></br>

                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={3}>
                    อื่นๆ โปรดระบุ
                  </Radio>
                  <br></br>
                </Radio.Group>
                {ReasonUnVac == 3 ?
                  <div stlye={{ marginTop: '5%', marginBottom: '5%' }}>
                    <label>หมายเหตุ: </label>
                    <div style={{ textAlign: 'center', marginTop: '1%', marginBottom: '5%' }}>
                      <TextArea maxLength={100}
                        name="RemarkUnvac"
                        value={RemarkUnvac}
                        showCount
                        onChange={handleChange("RemarkUnvac")} />
                    </div>
                  </div>
                  :
                  <div style={{ textAlign: 'center', marginTop: '5%' }}>
                  </div>
                }
              </div>

            }

          </TabPane>
          <TabPane tab="ข้อมูลการตรวจเชื้อ" key="2">
            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '2%' }}>
                <h2>การตรวจพบการติดเชื้อโควิด-19</h2>
                {/* <Radio.Group onChange={handleChange("DetectHistory")} style={{ fontSize: '1em' }} value={DetectHistory}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={0}>เคยตรวจแล้ว</Radio>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={1}>ยังไม่เคยตรวจ</Radio>
                </Radio.Group> */}
              </div>
            </div>
            {DetectHistory == 0 ?
              <div style={{ textAlign: 'center' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAddDetect}
                // icon={<PlusOutlined />}
                >
                  เพิ่มข้อมูล
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnsCovidDetctHistoryTH}
                    dataSource={tableDetectHistoryTH}
                    pagination={false}
                  />
                </div>
              </div> :
              null
            }

          </TabPane>
        </Tabs>


      </Form>
      {/* */}

    </div>
  )

  const newPostFormEN = () => (
    <div style={{ marginBlock: 15 }}>
      <Form className="mb-3" style={{ margin: 15, overflow: 'auto' }} onFinish={clickSubmit}>
        {/* <button style={{ margin: 15, float: 'right' }} >ยืนยันการบันทึกข้อมูล</button> */}
        {/* <button type="primary" >
          Primary
        </button> */}

        <Tabs style={{ marginLeft: 10 }} defaultActiveKey="1" onChange={callback}
          tabBarExtraContent={<Form.Item>
            <Button type="primary"
              size="large"
              style={{ float: 'right' }}
              // onClick={clickSubmit} 
              htmlType="submit"
            >
              Save
            </Button>
          </Form.Item>}
        >
          <TabPane tab="Vaccine History" key="1">

            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '5%' }}>
                <h2>Have you been vaccinated against COVID-19 ?</h2> :
                <Radio.Group onChange={handleChange("VacState")} style={{ fontSize: '1em' }} value={VacState}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={0}>Yes</Radio>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={1}>No</Radio>
                </Radio.Group>
              </div>
            </div>
            {VacState == 0 ?
              <div style={{ marginBottom: '5%' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAdd}
                // icon={<PlusOutlined />}
                >
                  Add
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnEN}
                    dataSource={tableDataEN}
                    pagination={false}
                  />
                </div>
              </div>
              :
              <div>
                <div style={{ textAlign: 'center' }}>
                  <h2>The reason you haven't been vaccinated?</h2>
                </div>
                <Radio.Group onChange={handleChange("ReasonUnVac")}
                  style={{ fontSize: '1em', marginLeft: '18%' }} value={ReasonUnVac}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={0}>
                    Personal choice.
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={1}>
                    On vaccine waiting list.
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={2}>
                    Waiting for the alternative vaccination.
                  </Radio>
                  <br></br>

                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={3}>
                    Others, please specify
                  </Radio>
                  <br></br>
                </Radio.Group>
                {ReasonUnVac == 3 ?
                  <div stlye={{ marginTop: '5%', marginBottom: '5%' }}>
                    <label>Remark: </label>
                    <div style={{ textAlign: 'center', marginTop: '1%', marginBottom: '5%' }}>
                      <TextArea maxLength={100}
                        name="RemarkUnvac"
                        value={RemarkUnvac}
                        showCount
                        onChange={handleChange("RemarkUnvac")} />
                    </div>
                  </div>
                  :
                  <div style={{ textAlign: 'center', marginTop: '5%' }}>
                  </div>
                }
              </div>

            }

          </TabPane>
          <TabPane tab="Detection History" key="2">
            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '2%' }}>
                <h2>Covid-19 Detection History</h2>
                {/* <Radio.Group onChange={handleChange("DetectHistory")} style={{ fontSize: '1em' }} value={DetectHistory}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={0}>เคยตรวจแล้ว</Radio>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={1}>ยังไม่เคยตรวจ</Radio>
                </Radio.Group> */}
              </div>
            </div>
            {DetectHistory == 0 ?
              <div style={{ textAlign: 'center' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAddDetect}
                // icon={<PlusOutlined />}
                >
                  Add
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnsCovidDetctHistoryEN}
                    dataSource={tableDetectHistoryEN}
                    pagination={false}
                  />
                </div>
              </div> :
              null
            }

          </TabPane>
        </Tabs>


      </Form>
      {/* */}

    </div>
  )
  return (

    <div>

      <PageHeader
        className="site-page-header"
        onBack={() => window.location.replace('/vaccine-info')}
        title={localStorage.getItem('Language') == 'TH' ? titleTH : titleEN}
      />
      <div className="col-md-8 offset-md-2">
        {localStorage.getItem('Language') == 'TH' ?
          newPostFormTH()
          :
          newPostFormEN()
        }
      </div>
    </div>

  )
}
export default CovidInfoAdd
